import { render, staticRenderFns } from "./AgendaDoMedico.vue?vue&type=template&id=86d91396&"
import script from "./AgendaDoMedico.vue?vue&type=script&lang=js&"
export * from "./AgendaDoMedico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports